import { CardFacadeBase } from 'utils/facades/card-facade-base';

class FormFacade extends CardFacadeBase {}

export { FormFacade };
